import { defineMessages } from 'react-intl';

export default defineMessages({
    dashboard: {
        id: 'portal.views.home-page-layout.Dashboard',
        defaultMessage: 'Dashboard',
    },
    serviceRequests: {
        id: 'portal.views.home-page-layout.Service Requests',
        defaultMessage: 'Service Requests',
    },
    quoteRequests: {
        id: 'portal.views.home-page-layout.Quote Requests',
        defaultMessage: 'Quote Requests',
    },
    salvageBids: {
        id: 'portal.views.home-page-layout.Salvage Bids',
        defaultMessage: 'Salvage Bids',
    },
    serviceRequestName: {
        id: 'portal.views.dashboard-table.service-request.Name',
        defaultMessage: 'Name',
    },
    serviceRequestClaimNumber: {
        id: 'portal.views.dashboard-table.service-request.Claim Number',
        defaultMessage: 'Claim Number',
    },
    serviceRequestProgress: {
        id: 'portal.views.dashboard-table.service-request.Progress',
        defaultMessage: 'Progress',
    },
    serviceRequestRequestType: {
        id: 'portal.views.dashboard-table.service-request.Request Type',
        defaultMessage: 'Request Type',
    },
    serviceRequestDueDate: {
        id: 'portal.views.dashboard-table.service-request.Due Date',
        defaultMessage: 'Due Date',
    },
    serviceRequestServiceType: {
        id: 'portal.views.dashboard-table.service-request.Service Type',
        defaultMessage: 'Service Type',
    },
    serviceRequestProgressAcceptWork: {
        id: 'servicerequest.views.service-requests.progress.Accept Work',
        defaultMessage: 'Accept Work',
    },
    serviceRequestProgressDeclineWork: {
        id: 'servicerequest.views.service-requests.progress.Decline Work',
        defaultMessage: 'Decline Work',
    },
    serviceRequestProgressCompleteWork: {
        id: 'servicerequest.views.service-requests.progress.Complete Work',
        defaultMessage: 'Complete Work',
    },
    serviceRequestProgressCancelWork: {
        id: 'servicerequest.views.service-requests.progress.Cancel Work',
        defaultMessage: 'Cancel Work',
    },
    serviceRequestProgressAddInvoice: {
        id: 'servicerequest.views.service-requests.progress.Add Invoice',
        defaultMessage: 'Add Invoice',
    },
    serviceRequestProgressResumeWork: {
        id: 'servicerequest.views.service-requests.progress.Resume Work',
        defaultMessage: 'Resume Work',
    },
    serviceRequestProgressAddQuote: {
        id: 'servicerequest.views.service-requests.progress.Add Quote',
        defaultMessage: 'Add Quote',
    },
    searchNameOrClaim: {
        id: 'portal.views.dashboard-table.service-request.Search name or claim number',
        defaultMessage: 'Search name or claim number...',
    },
    serviceRequstProgressRequested: {
        id: 'portal.views.dashboard-table.service-request.Requested',
        defaultMessage: 'Requested',
    },
    serviceRequstProgressInProgress: {
        id: 'portal.views.dashboard-table.service-request.In Progress',
        defaultMessage: 'In Progress',
    },
    serviceRequstProgressVendorWaiting: {
        id: 'portal.views.dashboard-table.service-request.Vendor Waiting',
        defaultMessage: 'Vendor Waiting',
    },
    serviceRequstProgressDeclined: {
        id: 'portal.views.dashboard-table.service-request.Declined',
        defaultMessage: 'Declined',
    },
    serviceRequstProgressCanceled: {
        id: 'portal.views.dashboard-table.service-request.Canceled',
        defaultMessage: 'Canceled',
    },
    serviceRequstProgressDraft: {
        id: 'portal.views.dashboard-table.service-request.Draft',
        defaultMessage: 'Draft',
    },
    serviceRequstProgressExpired: {
        id: 'portal.views.dashboard-table.service-request.Expired',
        defaultMessage: 'Expired',
    },
    serviceRequstProgressWorkComplete: {
        id: 'portal.views.dashboard-table.service-request.Work Complete',
        defaultMessage: 'Work Complete',
    },
    serviceRequstQuoteStatusQuoted: {
        id: 'portal.views.dashboard-table.service-request.Quoted',
        defaultMessage: 'Quoted',
    },
    serviceRequstQuoteStatusNoQuote: {
        id: 'portal.views.dashboard-table.service-request.No Quote',
        defaultMessage: 'No Quote',
    },
    serviceRequstQuoteStatusApproved: {
        id: 'portal.views.dashboard-table.service-request.Approved',
        defaultMessage: 'Approved',
    },
    serviceRequstQuoteStatusWaitingforQuote: {
        id: 'portal.views.dashboard-table.service-request.Waiting for Quote',
        defaultMessage: 'Waiting for Quote',
    },
    serviceRequstQuoteStatusWaitingforApproval: {
        id: 'portal.views.dashboard-table.service-request.Waiting for Approval',
        defaultMessage: 'Waiting for Approval',
    }

});
